import { styled } from '@mui/material';
import { Typography } from 'shared/mui/Typography';

export const StyledTypography = styled(Typography)({
  fontSize: '14px',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
}) as typeof Typography;
